import Vue from 'vue'
import api from '../../api/api'

const school = {
  state: {
    list: [],
    selectList: [],
    page: {}
  },

  mutations: {
    SET_SCHOOL_LIST(state, data) {
      state.list = data.list || []
      state.page = {
        page:data.pageno,
        total:data.totalcount
      }
    },
    SET_SCHOOL_SELECT(state, data) {
      state.selectList = data.list || []
    }
  },

  actions: {
    async getSchoolList({ commit, rootState},pageNo) {
      if(pageNo) {
        let params = {
          pageNo: -1
        }
        let ret = await api.getSchool(params)
        commit('SET_SCHOOL_SELECT', ret.data)
      } else {
        let params = JSON.parse(JSON.stringify(rootState.route.query))
        if(params.area) {
          if(params.area[0]) {
            params.province = params.area[0]
          }
          if(params.area[1]) {
            params.city = params.area[1]
          }
          if(params.area[2]) {
            params.county = params.area[2]
          }
          delete params.area
        }
        let ret = await api.getSchool(params)
        commit('SET_SCHOOL_LIST', ret.data)
      }
    }
  }

};

export default school


// WEBPACK FOOTER //
// ./src/store/modules/school.js